/**
 * Desliga console.log/debug/info no app publicado.
 *
 * São centenas de console.log, alguns com token de acesso, token FCM e dados
 * de usuário. No navegador ficam expostos a extensões e a quem olha a tela;
 * no Android o console do WebView vai para o logcat. warn e error continuam.
 *
 * Para depurar num aparelho: localStorage.setItem("av_debug", "1") e recarregar.
 */
export function silenciarConsoleDeDebug(): void {
  let debug = false;
  try {
    debug = localStorage.getItem("av_debug") === "1";
  } catch {
    debug = false;
  }
  if (debug) {
    return;
  }
  const nada = () => undefined;
  console.log = nada;
  console.debug = nada;
  console.info = nada;
}
